import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface ISecondContactFormMeta {
    firstName2: FormInputMeta;
    lastName2: FormInputMeta;
    position2: FormInputMeta;
    phone2: FormInputMeta;
    email2: FormInputMeta;

}

const secondContactFormMeta = {} as ISecondContactFormMeta;

secondContactFormMeta.firstName2 = {
    name: "firstName2",
    type: "text",
    label: "Prénom",
    placeholder: "Prénom",
    validation: yup.string()
};

secondContactFormMeta.lastName2 = {
    name: "lastName2",
    type: "text",
    label: "Nom",
    placeholder: "Nom",
    validation: yup.string(),
};

secondContactFormMeta.position2 = {
    name: "position2",
    type: "text",
    label: "Fonction",
    placeholder: "Fonction",
    validation: yup.string(),
};

secondContactFormMeta.phone2= {
    name: "phone2",
    type: "text",
    label: "Téléphone",
    placeholder: "Téléphone",
    validation: yup.string(),
};

secondContactFormMeta.email2= {
    name: "email2",
    type: "text",
    label: "E-mail",
    placeholder: "E-mail",
    validation: yup.string(),
};

export default secondContactFormMeta;